import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

export const LegendContainer = styled.div`
    display: flex;
    padding-top: 20px;
    padding-bottom: 40px;

    ${BaseStyle.Mixins.screenSizes.small} {
        display: block;
        padding-top: 0;
        padding-bottom: 20px;
    }
`;

export const Legend = styled.div`
    display: flex;
    align-items: center;
    ${BaseStyle.Mixins.fontStyles.desktop.body3}
    padding-right: 16px;

    ${BaseStyle.Mixins.screenSizes.small} {
        padding-bottom: 20px;
    }
`;

export const ButtonContainer = styled.div`
    ${BaseStyle.Mixins.gaps.large}
    display: flex;
    justify-content: center;
    margin-bottom: 24px;

    ${BaseStyle.Mixins.screenSizes.small} {
        ${BaseStyle.Mixins.gaps.medium}
    }
`;

export const ButtonText = styled.span<{ $isLeft?: boolean }>`
    ${({ $isLeft }) => ($isLeft ? 'padding-left' : 'padding-right')}: 12px;
`;

export const ListViewContainer = styled.div<{ $isClubPage?: boolean }>`
    ${BaseStyle.Mixins.screenSizes.large} {
        margin-top: ${({ $isClubPage }) => ($isClubPage ? '-55px' : '0')};
    }
`;

export const OddsProviderContainer = styled.div`
    ${BaseStyle.Mixins.screenSizes.medium} {
        margin-top: 56px;
    }
`;
